import React, { useState, useEffect, useRef } from "react";
import {
  VegaFlex,
  VegaForm,
  VegaFont,
  VegaImageUploader,
  VegaRichTextEditor,
  VegaInput,
  VegaButton,
  VegaFileUploader,
  VegaLoadingIndicator,
} from "@heartlandone/vega-react";
import { VegaNotify } from "@heartlandone/vega";
import { _fetch } from 'Chore/Request';
import { PATH } from 'Chore/Apis';
import MultiImageUploader from "Components/MultiImageUploader";
import { isValidFile } from 'Chore/Utils';


const { ATTACHMENT, ATTACHMENT_DELETE } = PATH;
const FOURTH_STEP = 3;
window.imageIds = [];
window.imageUrls = [];
window._documentInfo = [];
window.isMultiImageInitialized = false;
window.isAttachmentInitialized = false;
function StepFour({ currentStep, onPreviousClick = () => { }, form ={}, onNextClick = () => { }, isEdit = false }) {
  const _isShow = () => currentStep === FOURTH_STEP;
  const [isdisbaled, setIsdisbaled] = useState(true);
  const [cover, setCover] = useState(null);
  const [coverId, setCoverId] = useState('');
  const [images, setImages] = useState({});
  const [imageIds, setImageIds] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [HTMLDescription, setHTMLDescription] = useState('');
  const richText = useRef();
  const [isCoverloading, setIsCoverLoading] = useState(false);
  const isUploadingCoverRef = useRef(false);
  useEffect(() => {
    if (isEdit && form?.cover?.url && currentStep === FOURTH_STEP) {
      setIsCoverLoading(true);
      fetch(form.cover.url).then(res => {
        if (res.ok) {
          window.coverUrl = form.cover.url;
          return res.blob();
        }
        return null;
      }).then(blob => {
        if (blob && ['image/png', 'image/jpeg', 'image/jpg'].includes(blob.type.toLowerCase())) {
          setCover(blob);
          setCoverId(form.cover.id);
        }
      })
        .finally(() => setIsCoverLoading(false));
    }
  }, [form?.cover, isEdit, currentStep]);

  useEffect(() => {
    if (isEdit && form?.images?.length > 0 && currentStep === FOURTH_STEP) {
      const _imageUrls = form?.images.map((img) => ({ id: img.id, url: img.url }));
      !window.isMultiImageInitialized && (window.imageUrls = _imageUrls);
      const _imagesids = _imageUrls.map((img) => img.id);
      !window.isMultiImageInitialized && (window.imageIds = _imagesids);
      !window.isMultiImageInitialized && (setImageIds(_imagesids));
      const _images = {};
      _imageUrls.forEach((img) => {
        _images[img.id] = img.url;
      });
      setImages(_images);
      window.isMultiImageInitialized = true;
    } else if(!isEdit){
      window.imageIds = [];
      window.imageUrls = [];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, form?.images]);

  useEffect(() => {
    if (isEdit && currentStep === FOURTH_STEP) {
      const __documents = form?.documents.map((doc) => ({ key: doc.id, name: doc.originalFileName, status: "done" }));
      !window.isAttachmentInitialized && (window._documentInfo = __documents);
      setDocuments(__documents);
      window.isAttachmentInitialized && setDocuments(window._documentInfo.map(doc => ({ status: "done", ...doc })));
      window.isAttachmentInitialized = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, form?.documents]);

  const onRichEditChange = (evt) => {
    setTimeout(() => {setIsdisbaled(!evt.target.isValid)}, 100)
  }

  const onCoverChange = async (e) => {
    if (isUploadingCoverRef.current) return;
    const file = e.detail;
    if (file && file.name && isValidFile(file)) {
      isUploadingCoverRef.current = true;
      setIsCoverLoading(true);
      try {
        const res = await _fetch({
          method: "POST",
          file: file,
          api: `${ATTACHMENT}`,
        });
        if (res.code === 2200) {
          const data = res?.payload;
          setCover({ id: res.payload.id, url: res.payload.url });
          setCoverId(data.id);
          window.coverUrl = data.url;
        }
      } finally {
        setIsCoverLoading(false);
        isUploadingCoverRef.current = false;
      }
    } else if (file && file.name && !isValidFile(file)) {
      e.preventDefault();
      e.target.value = null;
      VegaNotify.open({ type: "error", message: "The file type or size is invalid." });
      return;
    }
  }
  const onCoverRemove = async () => {
    if(!coverId) return;
    setIsCoverLoading(true);
    _fetch({
      method: 'DELETE',
      api: ATTACHMENT_DELETE(coverId),
    }).then((res) => {
      if (res.code === 2200) {
        setCoverId(null);
        setCover(null);

        window.coverUrl = '';
      }
      setIsCoverLoading(false);
    });
  }

  const onImageChange = async ({
    file = null,
  }, e) => {
    if (file && isValidFile(file)) {
      return _fetch({
        method: 'POST',
        file: file,
        api: `${ATTACHMENT}`,
      }).then(res => {
        if (res.code === 2200) {
          const data = res?.payload;
          const _images = { ...images, [data.id]: file }
          setImages(_images);
          window.imageIds = [...window.imageIds, data.id];
          setImageIds(window.imageIds);
          return _images;
        }
      });
    } else {
      e.preventDefault();
      VegaNotify.open({ type: 'error', message: 'The file type or size is invalid.' });
      return;
    }
  }

  const onImageRemove = async (id) => {
    return _fetch({
      method: 'DELETE',
      api: ATTACHMENT_DELETE(id),
    }).then(res => {
      if (res.code === 2200) {
        const newImages = { ...images };
        delete newImages[id];
        setImages(newImages);
        window.imageIds = window.imageIds.filter( _id => _id !== parseInt(id));
        setImageIds(window.imageIds);
        return id;
      }
    });
  }

  const onAttachmentChange = async (e) => {
    const _files = e.detail.map(_ => _.url);
    const sizeValidFiles = _files.filter((file, index) => {
      if(!isValidFile(file, { ext: [], size: 15 * 1024 * 1024 })) {
        const doc = { 
          key: _files[index].name, 
          name: _files[index].name, 
          status: "error", 
          message: `The size of file ${_files[index].name} should not greater than 15MB.` 
        };
        window._documentInfo = [...window._documentInfo, doc];
        VegaNotify.open({ type: 'error', message: doc.message });
        return false;
      }
      return true;
    });

    Promise.all(sizeValidFiles.map((file) => {
      return _fetch({
        method: 'POST',
        file: file,
        api: `${ATTACHMENT}`,
      });
    })).then(res => {
      res.forEach((r, index) => {
        if(r.code === 2200) {
          const doc = { 
            key: r.payload.id, 
            name: r.payload.originalFileName, 
            status: "done" 
          };
          window._documentInfo = [...window._documentInfo, doc];
        } else {
          const doc = { 
            key: _files[index].name, 
            name: _files[index].name, 
            status: "error", 
            message: r.message 
          };
          window._documentInfo = [...window._documentInfo, doc];
          VegaNotify.open({ type: 'error', message: doc.message });
        }
      });
    }).finally(() => {
      setDocuments(window._documentInfo);
    });
  }

  const onAttachmentRemove = async (e) => {
    if (e.detail.status === 'error') {
      window._documentInfo = window._documentInfo.filter(doc => doc.status !== 'error');
      setDocuments(window._documentInfo);
      return;
    }
    const id = e.detail.key;
    return _fetch({
      method: 'DELETE',
      api: ATTACHMENT_DELETE(id),
    }).then(async res => {
      if (res.code === 2200) {
        window._documentInfo = window._documentInfo.filter(doc => doc.key !== id);
        setDocuments(window._documentInfo);
      }
    });
  }

  const onVegaImageInserted = async (e) => {
    const {file, sendBackUploadedURLCallback} = e.detail;
    return _fetch({
      method: 'POST',
      file: file,
      api: `${ATTACHMENT}`,
    }).then(res => {
      if (res.code === 2200) {
        const data = res?.payload;
        sendBackUploadedURLCallback(data.url);
      }
    });
  }

  const parseRichEditorContent = () => {
    if(richText.current) {
      richText.current.componentOnReady().then(() => {
        const _HTMLDescription = richText.current.shadowRoot.querySelector('vega-rich-text-content').shadowRoot.querySelector('.rich-text-content').innerHTML;
        setHTMLDescription(_HTMLDescription);
      })
    }
  }

  return (
    <VegaFlex className={`m-t-32${_isShow() ? "" : " display-none"}`} direction={"col"} gap="size-48">
      <VegaFlex gap={'size-32'} direction={'col'}>
        <h2 style={{ margin: 0 }} className="form-step-title ">
          Details
        </h2>
        <div style={{ position: "relative", display: "inline-block" }}>
        <VegaInput type="hidden" data-vega-form="coverId" value={coverId}/>
        {isCoverloading && <VegaLoadingIndicator mode={`indeterminate`} style={{ display: 'block', position: 'absolute', top: 60, left: 75, zIndex: 9999 }} />}
        <VegaImageUploader
          width={192}
          height={106}
          label="Add Cover"
          value={cover}
          showReplaceButton={false}
          onVegaChange={onCoverChange}
          onVegaRemove={onCoverRemove}
        />
        </div>
        <ul className="font-light-text-color-secondary f-size-14 f-weight-400 p-l-16 m-0">
          <li className="m-b-8">Recommended image size: 1200*600px or image close 2:1 ratio</li>
          <li className="m-b-8">Maximum file size: 4MB</li>
          <li className="m-b-8">Accept file types: JPEG, JPG, PNG</li>
        </ul>
      </VegaFlex>
      <VegaRichTextEditor
        label="Description"
        placeholder="Enter details here..."
        className="w-full"
        required
        ref={richText}
        data-vega-form="descriptionObject"
        onVegaChange={onRichEditChange}
        onVegaImageInserted={onVegaImageInserted}
      />
      <VegaInput type="hidden" data-vega-form="HTMLDescription" value={HTMLDescription} />
      <VegaFlex direction={'col'} gap={'size-32'}>
        <div>
          <VegaFont>Add Image</VegaFont>
          <MultiImageUploader maxFiles={4} onImageChangeCallback={onImageChange} onImageRemoveCallback={onImageRemove} imageUrls={window.imageUrls} isEdit={isEdit}/>
          <VegaInput type="hidden" data-vega-form="imageIds" value={imageIds.join('-')} />
        </div>
        <ul className="font-light-text-color-secondary f-size-14 f-weight-400 p-l-16 m-0">
          <li className="m-b-8">Recommended image size: 1200*600px or image close 2:1 ratio</li>
          <li className="m-b-8">Maximum images: 4</li>
          <li className="m-b-8">Maximum file size: 4MB</li>
          <li className="m-b-8">Accept file types: JPEG, JPG, PNG</li>
        </ul>
      </VegaFlex>
      <VegaFlex direction={'col'}>
        <VegaForm data-vega-form='videoUrls'>
            <VegaFlex direction={'col'} gap={'size-24'}>
              <VegaInput label="Video URL" data-vega-form={0}/>
          </VegaFlex>
        </VegaForm>
      </VegaFlex>
      <VegaFlex direction={'col'}>
        <VegaFileUploader
          label="Add Attachment"
          value={documents}
          maxCount={10}
          onVegaSelectedFileChange={onAttachmentChange}
          onVegaRemove={onAttachmentRemove}
        />
        <span className="font-light-text-color-secondary f-size-14 f-weight-400 m-l-8 m-t-8">
          Maximum file size is 15MB.
        </span>
      </VegaFlex>
      <VegaInput type="hidden" data-vega-form="documentIds" value={documents.filter(doc => doc.status !== 'error').map((d) => d.key).join('-')} />

      <VegaFlex justifyContent='space-between' alignItem={'center'} className='m-t-40 p-t-20 p-b-48 border-none' style={{ marginBottom: -24 }}>
        <VegaButton variant="secondary" label={"Previous"} onVegaClick={() => {
          onPreviousClick('Details')
          parseRichEditorContent();
        }} />
        <VegaButton label={"Next"} disabled={isdisbaled || isCoverloading } onVegaClick={() => {
          onNextClick('Details')
          parseRichEditorContent();
        }} />
      </VegaFlex>
    </VegaFlex>
  );
}

export default StepFour;